<template>
  <vs-popup id="popupSearchCompany" :title="popupTitle" :active.sync="showPopup" style="z-index: 53001">
    <div class="flex flex-col md:flex-row justify-between gap-y-4 shadow rounded-lg p-6 mb-6" style="border-bottom: 1px solid #e0e0e0">
      <div class="flex items-center">
        <p class="search-label" style="width: 80px">검색어</p>
        <ml-input ref="inputKeyword" v-model="search.keyword" @keyup.enter="handleClickSearch" class="w-full md:w-auto" />
      </div>
      <vs-button color="secondary" @click="handleClickSearch" class="ml-auto">검색</vs-button>
    </div>

    <vs-row>
      <vs-col style="max-height: 500px; overflow-y: auto">
        <vs-table stripe ref="table" :sst="true" :max-items="page.perPage" :data="companyList" noDataText="데이터가 없습니다" @selected="handleItemClickDetail" @dblSelection="handleClickSelect">
          <template slot="thead">
            <vs-th class="">No.</vs-th>
            <vs-th class="">부서명</vs-th>
            <vs-th class="">사업자등록번호</vs-th>
            <vs-th class="">담당자</vs-th>
            <vs-th class="">연락처</vs-th>
            <vs-th class="">비고</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :class="selectCompany.id === company.id ? 'active' : ''" :data="company" :key="index" v-for="(company, index) in data">
              <vs-td>{{ company.id }}</vs-td>
              <vs-td>{{ company.com_name }}</vs-td>
              <vs-td>{{ company.com_number }}</vs-td>
              <vs-td>{{ company.com_ceo }}</vs-td>
              <vs-td>{{ company.phone }}</vs-td>
              <vs-td></vs-td>
            </vs-tr>
          </template>
        </vs-table>

        <div class="vs-con-table">
          <div class="con-pagination-table vs-table--pagination">
            <k-pagination :total="page.lastPage ? page.lastPage : 0" v-model="page.current" @change="handleChangePage"></k-pagination>
          </div>
        </div>
      </vs-col>

      <vs-col class="mt-4 flex" vs-align="center" vs-justify="flex-end">
        <vs-button class="mr-4" color="#EDEDED" text-color="black" type="filled" @click="handleClickClose">닫기 </vs-button>
        <vs-button class="" color="secondary" @click="handleClickSelect">선택</vs-button>
      </vs-col>
    </vs-row>
  </vs-popup>
</template>

<script>
import KPagination from "@/components/kPagination/kPagination";
export default {
  name: "PopupSearchCompany",
  props: {
    value: Boolean,
    selectId: [String, Number],
    fieldId: {
      type: Number | null,
      default: null,
    },
    title: {
      type: String,
      default: "",
    },
  },
  components: { KPagination },

  watch: {
    value(data) {
      this.showPopup = data;
      if (this.oldSelectCompany.id) {
        this.selectCompany = this.oldSelectCompany;
      }
    },
    selectId(id) {
      this.oldSelectCompanyId = id;
      if (this.companyList) {
        for (const company of this.companyList) {
          if (company.id === this.oldSelectCompanyId) {
            try {
              this.oldSelectCompany = company;
              this.selectCompany = company;
            } catch (e) {}
            break;
          }
        }
      }
    },
    showPopup(data) {
      this.$emit("input", data);
      this.selectCompany = this.oldSelectCompany;

      // 팝업이 열릴 때 목록을 조회한다.
      // (이전에는 k-pagination 이 mount 되며 발생시키는 change 이벤트에 의존했기 때문에,
      //  팝업이 닫혀있어도 목록 API 가 호출되었다)
      if (data) {
        this.page.current = 1;
        this.loadCompanyList();
      }
    },
  },
  computed: {
    popupTitle() {
      return this.title === "" ? "업체검색" : this.title;
    },
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    companyList() {
      const info = this.$store.state.company.companyListInfo;
      const list = this.$store.state.company.companyList;
      this.page.current = info.current_page;
      this.page.perPage = info.per_page;
      this.page.lastPage = info.last_page;

      for (const company of list) {
        if (company.id === this.oldSelectCompanyId) {
          this.oldSelectCompany = company;
          this.selectCompany = company;
          break;
        }
      }

      return list;
    },
  },
  data() {
    return {
      showPopup: false,

      oldSelectCompanyId: 0,
      oldSelectCompany: {},
      selectCompany: {},

      // 페이징
      page: {
        current: 1,
        lastPage: 1,
        perPage: 5,
      },

      // 겅색
      search: {
        keyword: "", // 검색어
      },
    };
  },

  mounted() {
    const backButtonRouteGuard = this.$router.beforeEach((to, from, next) => {
      if (this.showPopup) {
        this.showPopup = false;
        next(false);
        return;
      }
      next(true);
    });
    this.$once("hook:destroyed", () => {
      backButtonRouteGuard();
    });
  },

  created() {
    this.showPopup = this.value;
    this.oldSelectCompanyId = this.selectId;
  },

  methods: {
    async loadCompanyList() {
      const page = this.page.current;
      const perPage = this.page.perPage;
      const keyword = this.search.keyword;
      const projectId = this.projectId;

      let params = { page, perPage, keyword, projectId };
      if (this.fieldId) params = { ...params, fieldId: this.fieldId };

      await this.$store.dispatch("company/LOAD_COMPANY_LIST", params);
    },

    handleClickClose() {
      this.$emit("input", false);
      this.$emit("handleClickClose");
    },

    handleClickSearch() {
      this.loadCompanyList();
    },

    handleChangePage(page) {
      // 팝업이 닫혀있는 동안에는 조회하지 않는다.
      // (vs-popup 은 닫혀있어도 슬롯을 렌더링하므로, k-pagination 이 mount 되며 change 이벤트를 발생시킨다)
      if (!this.showPopup) {
        return;
      }
      this.page.current = page;
      this.loadCompanyList();
    },

    handleItemClickDetail(data) {
      if (this.selectCompany === data) {
        this.handleClickSelect();
      } else {
        this.selectCompany = data;
      }
    },

    handleClickSelect(data) {
      // 리스트에서 더블클릭됐을 때는 아이템 데이터가 전달된다
      if (data && data.id) {
        this.handleItemClickDetail(data);
      }

      this.$emit("input", false);
      this.$emit("handleClickSelect", this.selectCompany);
    },
  },
};
</script>

<style lang="scss" scoped>
#popupSearchCompany::v-deep .vs-popup {
  width: 90% !important;
  @media print, screen and (min-width: theme("screens.xl")) {
    width: 1200px !important;
  }

  .vs-con-table.stripe .tr-values.active {
    background: rgb(102, 112, 203) !important;
    color: #fff;
    font-width: bold;
  }
}
</style>
